import { UUID } from "angular2-uuid";
import moment from "moment";
export function hasValue(data: any) {
  if (data != "" && data != undefined && data != null) {
    return true;
  } else {
    return false;
  }
}
(<any>window).hasValue = hasValue;

export function generateUUID() {
  let uuidValue = UUID.UUID();
  return uuidValue;
}

export function getFormatDate(date: any) {
  return moment(date).format("MM/DD/YY hh:mm A");
}

/**
 * Lower case extension of a file name or of a path inside an archive, without the
 * leading dot. Returns an empty string when the name carries no extension.
 */
export function fileExtensionOf(path: string): string {
  const baseName = path.substring(path.lastIndexOf("/") + 1);
  const dotIndex = baseName.lastIndexOf(".");
  return dotIndex > 0 ? baseName.substring(dotIndex + 1).toLowerCase() : "";
}

/**
 * Renders a UTC ISO 8601 timestamp with an explicit UTC marker.
 *
 * The SCIM endpoints answer in UTC. Showing one of those as local time without
 * saying so misstates when a token actually stops working, so the suffix is not
 * optional decoration.
 */
export function formatUtc(iso: string | null | undefined): string {
  if (!iso) {
    return "";
  }
  const parsed = moment.utc(iso);
  return parsed.isValid() ? parsed.format("DD MMM YYYY, HH:mm [UTC]") : "";
}
